<template>
  <v-container class="ma-0 pa-6" v-resize="onResize" fluid>
    <v-row justify="center" dense>
      <v-col lg="6">
        <!-- <v-container class="pt-6">
          <v-row justify="center" dense class="pb-0 mb-0">
            <v-col cols="10" class="pa-0 ma-0">
              <v-textarea hide-details outlined solo no-resize rows="3" label="Leave a comment..."
                background-color="input" @keydown.enter="addComment" v-model="message">
                <template v-slot:append>
                  <v-btn class="mx-0" depressed @click="addComment">
                    Post
                  </v-btn>
                </template>
              </v-textarea>
            </v-col>
          </v-row> -->
        <v-card class="ma-0 pa-0" height="675">
          <v-toolbar flat class="card">
            <v-row align="center">
              <v-col lg="5">
                <v-autocomplete class="mt-7" outlined dense solo background-color="input" @click:clear="filtered=[]" clearable
                prepend-inner-icon="mdi-filter-outline" label="Filter" :items="['Status', 'Comments']" v-model="filter" @change="filterResults"/> 
              </v-col>
            </v-row>
          </v-toolbar>
          <v-divider/>
          <v-container class="ma-0 pa-0" style="max-height:600px; max-width: 850px; overflow-y:auto;">
            <v-row justify="center" justify-space-between class="ma-0 pa-0s">
              <v-col cols="10" class="ma-0 pa-0">
                <v-timeline dense>
                  <v-timeline-item fill-dot :icon="getIcon(i.message_type)"
                    v-for="(i, index) in filtered.length ? filtered : comments" :key="index"
                    :color="getIconColor(i.message_type)">
                    <v-row align="center" dense>
                      <span v-if="i.message_type==='status'" class="mt-4 text-capitalize text-body-2 font-weight-medium">
                        {{`Status Set to ${i.message}`}}
                      </span>
                    </v-row>
                    <v-card v-if="i.message_type==='comment'" class="elevation-2">
                      <v-card-title class="text-body-1 font-weight-medium">
                        {{i.name}}
                      </v-card-title>
                      <v-card-text class="text-body-2 font-weight-light">
                        {{i.message}}
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer />
                        <span></span>
                      </v-card-actions>
                    </v-card>
                  </v-timeline-item>
                </v-timeline>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ContractComments',

  props: {
    contract: Object
  },

  data: () => ({
    message: '',
    pageHeight: '',
    filter: '',
    filtered: []
  }),
  
  computed: {
    ...mapState(['comments'])
  },
  
  mounted () {
    this.pageHeight = window.innerHeight - 337
  },

  methods: {
    onResize () {
      this.pageHeight = window.innerHeight - 202
    },

    getIcon (key) {
      switch (key) {
        case 'status': 
          return 'mdi-cog'
        case 'comment': 
          return 'mdi-message-text'
        default:
          break
      }
    },

    getIconColor (key) {
      switch (key) {
        case 'status': 
          return 'grey'
        case 'comment': 
          return 'green'
        default:
          break
      }
    },

    filterResults () {
      const results = this.comments.filter((obj) => {
        return Object.keys(obj).reduce((acc, curr) => {
          return acc || obj[curr].toLowerCase().includes(this.filter.toLowerCase());
        }, false);
      })
      this.filtered = results 
    },

    async getComments () {
      await this.$contracts.getComments(this.contract.contract_uuid)
        .then(res => {
          this.$store.commit('SET_COMMENTS', res.data)
        }).catch(() => {
          this.dispatch('')
        })
    },

    async addComment () {
      const comment = {
        contract_uuid: this.contract.contract_uuid,
        message: this.message,
        message_type: 'comment',
        userid: 12
      }

      await this.$contracts.saveContractComment(comment)
        .then(() => {
          this.$store.dispatch('setSnackbar', { status: 'success', text: 'Comment Added to Contract' })
          this.message = ''
        }).catch(() =>
          this.$store.dispatch('setSnackbar', { status: 'error', text: 'Failed to Add Comment' }
        ))
        this.getComments()
    }
  }
}
</script>
